import { gql } from "graphql-request";

export const queryCategories = gql`
  query CategoriesNav($locale: I18NLocaleCode) {
    categories(sort: "order:ASC", locale: $locale) {
      data {
        attributes {
          slug
          name
          description
          order
        }
      }
    }
  }
`;

export const queryHomePage = gql`
  query HomePage($locale: I18NLocaleCode) {
    pageHome(locale: $locale) {
      data {
        attributes {
          keywords
          metaDescription
          pageTitle
        }
      }
    }
    categories(sort: "order:ASC", locale: $locale) {
      data {
        attributes {
          slug
          name
          description
          order
        }
      }
    }
  }
`;

export const queryServicesPage = gql`
  query ServicesPage($locale: I18NLocaleCode) {
    pageService(locale: $locale) {
      data {
        attributes {
          pageTitle
          keywords
          metaDescription
        }
      }
    }
    categories(sort: "order:ASC", locale: $locale) {
      data {
        id
        attributes {
          name
          description
          slug
          subCategories {
            data {
              attributes {
                name
                service(pagination: { limit: 100 }) {
                  name
                  id
                  price
                  description
                  plus
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const queryProduitsPage = gql`
  query ProduitsPage($locale: I18NLocaleCode) {
    pageProduct(locale: $locale) {
      data {
        attributes {
          title
          intro
          pageTitle
          keywords
        }
      }
    }
    products(locale: $locale) {
      data {
        id
        attributes {
          name
          link
          coupDeCoeur
          description
          image {
            data {
              attributes {
                name
                hash
                ext
              }
            }
          }
        }
      }
    }
  }
`;

export const queryPageSoinsCuirChevelu = gql`
  query SoinsCuirChevelu($locale: I18NLocaleCode) {
    soinsCuirChevelu(locale: $locale) {
      data {
        attributes {
          title
          pageTitle
          keywords
          metaDescription
          Description
        }
      }
    }
  }
`;

export const queryPageAbout = gql`
  query PageAbout($locale: I18NLocaleCode) {
    pageAbout(locale: $locale) {
      data {
        attributes {
          title
          intro
          pageTitle
          keywords
          carousel {
            data {
              attributes {
                name
                hash
                ext
              }
            }
          }
        }
      }
    }
  }
`;

export const queryPageContact = gql`
  query PageContact($locale: I18NLocaleCode) {
    pageContact(locale: $locale) {
      data {
        attributes {
          tel
          email
          address
          openingHours {
            day
            hour
          }
          socialMedia {
            facebook
            instagram
          }
          keywords
          pageTitle
        }
      }
    }
  }
`;
